<template>
  <table>
    <caption>일반소식 목록</caption>
    <thead>
      <tr>
        <th>번호</th>
        <th>받는사람</th>
        <th>제목</th>
        <th>내용</th>
        <th>작성자</th>
        <th>작성시간</th>
        <th>최초전송시간</th>
        <th>확인한사람</th>
        <th>전송이력</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="rowData in sourceList">
        <td>{{rowData.id}}</td>
        <td>{{rowData.rcpDesc}}</td>
        <td>{{rowData.boardTitle}}</td>
        <td>{{rowData.boardContent}}</td>
        <td>{{rowData.userName}}</td>
        <td>{{$utils.timeText(rowData.createDate)}}</td>
        <td>{{$utils.timeText(rowData.pushFirstDate)}}</td>
        <td>{{rowData.rcpReadDesc}}</td>
        <td>{{rowData.sendCount ? `있음` : '없음'}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    sourceList: Array
  }
};
</script>

<style>
</style>